import { render, staticRenderFns } from "./KioskLoading.vue?vue&type=template&id=8a2a8e56&"
import script from "./KioskLoading.vue?vue&type=script&lang=js&"
export * from "./KioskLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports